import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const devices: IMcAppType = {
  name: "devices",
  path: "/my/devices",
  description: "Connected devices landing page",
  navFlow: NavFlow.TAB,
  title: "Devices",
  parent: Tab.DEVICES,
  conditions: {
    intent: "devices",
    customerType: CustomerType.kraken,
  },
};
